var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-324.000000, -252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(324.000000, 252.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    stroke: "#24637D",
    cx: 9.5,
    cy: 9.5,
    r: 2.83333333
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 9.095238)",
    fill: "#24637D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.5 C0,0.223857625 0.215057373,0 0.490478516,0 L3.50952148,0 C3.78040529,0 4,0.231933594 4,0.5 L4,0.5 C4,0.776142375 3.78494263,1 3.50952148,1 L0.490478516,1 C0.219594711,1 0,0.768066406 0,0.5 L0,0.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,0.5 C15,0.223857625 15.2150574,0 15.4904785,0 L18.5095215,0 C18.7804053,0 19,0.231933594 19,0.5 L19,0.5 C19,0.776142375 18.7849426,1 18.5095215,1 L15.4904785,1 C15.2195947,1 15,0.768066406 15,0.5 L15,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.500000, 9.595238) rotate(-90.000000) translate(-9.500000, -9.595238) translate(0.000000, 9.095238)",
    fill: "#24637D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.5 C0,0.223857625 0.215057373,0 0.490478516,0 L3.50952148,0 C3.78040529,0 4,0.231933594 4,0.5 L4,0.5 C4,0.776142375 3.78494263,1 3.50952148,1 L0.490478516,1 C0.219594711,1 0,0.768066406 0,0.5 L0,0.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,0.5 C15,0.223857625 15.2150574,-1.77635684e-15 15.4904785,-1.77635684e-15 L18.5095215,-1.77635684e-15 C18.7804053,-1.77635684e-15 19,0.231933594 19,0.5 L19,0.5 C19,0.776142375 18.7849426,1 18.5095215,1 L15.4904785,1 C15.2195947,1 15,0.768066406 15,0.5 L15,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.500000, 9.595238) rotate(-45.000000) translate(-9.500000, -9.595238) translate(0.000000, 9.095238)",
    fill: "#24637D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.56319402e-13,0.5 C-1.56319402e-13,0.223857625 0.215057373,7.82152121e-14 0.490478516,7.82152121e-14 L3.50952148,7.82152121e-14 C3.78040529,7.82152121e-14 4,0.231933594 4,0.5 L4,0.5 C4,0.776142375 3.78494263,1 3.50952148,1 L0.490478516,1 C0.219594711,1 -1.56319402e-13,0.768066406 -1.56319402e-13,0.5 L-1.56319402e-13,0.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,0.5 C15,0.223857625 15.2150574,2.38087328e-13 15.4904785,2.38087328e-13 L18.5095215,2.38087328e-13 C18.7804053,2.38087328e-13 19,0.231933594 19,0.5 L19,0.5 C19,0.776142375 18.7849426,1 18.5095215,1 L15.4904785,1 C15.2195947,1 15,0.768066406 15,0.5 L15,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.500000, 9.595238) rotate(-315.000000) translate(-9.500000, -9.595238) translate(0.000000, 9.095238)",
    fill: "#24637D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.2596148e-13,0.5 C3.2596148e-13,0.223857625 0.215057373,-7.24975635e-13 0.490478516,-7.24975635e-13 L3.50952148,-7.24975635e-13 C3.78040529,-7.24975635e-13 4,0.231933594 4,0.5 L4,0.5 C4,0.776142375 3.78494263,1 3.50952148,1 L0.490478516,1 C0.219594711,1 3.2596148e-13,0.768066406 3.2596148e-13,0.5 L3.2596148e-13,0.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,0.5 C15,0.223857625 15.2150574,-7.28528349e-13 15.4904785,-7.28528349e-13 L18.5095215,-7.28528349e-13 C18.7804053,-7.28528349e-13 19,0.231933594 19,0.5 L19,0.5 C19,0.776142375 18.7849426,1 18.5095215,1 L15.4904785,1 C15.2195947,1 15,0.768066406 15,0.5 L15,0.5 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkSun);
export default __webpack_public_path__ + "static/media/dark-sun.524fdef42f24db203d175a7f8d5377f9.svg";
export { ForwardRef as ReactComponent };